export default [{
    name: 'dashboard',
    children: [
        {
            name:'test',
            path:'/test/demo',
            component:resolve=>require(['./filedemo.vue'],resolve)
        },
        {
            name:'baselist',
            path:'/System/Base/Baselist',
            component:resolve=>require(['./list.vue'],resolve)
        },
        {
            name: 'citybaseList',
            path: '/base/citybase/citybaseList',
            component: resolve => require(['./citybase/citybaseList.vue'], resolve)
        },{
            name: 'citybaseDetail',
            path: '/base/citybase/citybaseDetail',
            component: resolve => require(['./citybase/citybaseDetail.vue'], resolve)
        },{
            name: 'airlineList',
            path: '/base/airlinebase/airlineList',
            component: resolve => require(['./airlinebase/airlineList.vue'], resolve)
        },{
            name: 'airlineDetail',
            path: '/base/airlinebase/airlineDetail',
            component: resolve => require(['./airlinebase/airlineDetail.vue'], resolve)
        },{
            name: 'airspaceDetail',
            path: '/base/airspacebase/airspaceDetail',
            component: resolve => require(['./airspacebase/airspaceDetail.vue'], resolve)
        },{
            name: 'airspaceList',
            path: '/base/airspacebase/airspaceList',
            component: resolve => require(['./airspacebase/airspaceList.vue'], resolve)
        },{
            name: 'airspanceRank',
            path: '/base/airspacebase/airspanceRank',
            component: resolve => require(['./airspacebase/airspanceRank.vue'], resolve)
        },{
            path: '/base/flgihtBase/flightBaseDate',
            name: 'flightBaseflightBaseDate',
            component: resolve => require(['./flightBase/flightBaseDate.vue'], resolve)
        },{
            path: '/base/flightBase/airportDetail',
            name: 'flightBaseairportDetail',
            component: resolve => require(['./flightBase/airportDetail.vue'], resolve)
        },{
         path: '/base/hotelBaseDate/hotelBaseDate',
         name: 'hotelBaseDatehotelBaseDate',
         component: resolve => require(['./hotelBaseDate/hotelBaseDate.vue'], resolve)
        },{
         path: '/base/hotelBaseDate/hotelBaseDetail',
         name: 'hotelBaseDatehotelBaseDetail',
         component: resolve => require(['./hotelBaseDate/hotelBaseDetail/hotelBaseDetail.vue'], resolve)
        },{
         name: 'alliance',
         path: '/base/alliance/alliance',
         component: resolve => require(['./alliance/alliance.vue'], resolve)
        },{
         name: 'addVisa',
         path: '/base/hotelBaseDate/basicConfigurat/addVisa',
         component: resolve => require(['./hotelBaseDate/basicConfigurat/addVisa.vue'], resolve)
        },{
         name: 'basicConfigurat',
         path: '/base/hotelBaseDate/basicConfigurat/basicConfigurat',
         component: resolve => require(['./hotelBaseDate/basicConfigurat/basicConfigurat.vue'], resolve)
        },{
         name: 'facilityAttribute',
         path: '/base/hotelBaseDate/basicConfigurat/facilityAttribute',
         component: resolve => require(['./hotelBaseDate/basicConfigurat/facilityAttribute.vue'], resolve)
        },{
         name: 'configurat',
         path: '/base/hotelBaseDate/basicConfigurat/configurat',
         component: resolve => require(['./hotelBaseDate/basicConfigurat/configurat.vue'], resolve)
        },{
         name: 'BusinessDistrict',
         path: '/base/hotelBaseDate/basicConfigurat/BusinessDistrict',
         component: resolve => require(['./hotelBaseDate/basicConfigurat/BusinessDistrict.vue'], resolve)
        },{
         name: 'servicesAdd',
         path: '/base/hotelBaseDate/basicConfigurat/servicesAdd',
         component: resolve => require(['./hotelBaseDate/basicConfigurat/servicesAdd.vue'], resolve)
        },{
         name: 'leisureFacility',
         path: '/base/hotelBaseDate/basicConfigurat/leisureFacility',
         component: resolve => require(['./hotelBaseDate/basicConfigurat/leisureFacility.vue'], resolve)
        },{
         name: 'infrastructure',
         path: '/base/hotelBaseDate/basicConfigurat/infrastructure',
         component: resolve => require(['./hotelBaseDate/basicConfigurat/infrastructure.vue'], resolve)
        },{
         name: 'creditChoose',
         path: '/base/hotelBaseDate/creditChoose',
         component: resolve => require(['./hotelBaseDate/hotelBaseDetail/creditChoose.vue'], resolve)
        },{
         name: 'detailFacilityChoose',
         path: '/base/hotelBaseDate/detailFacilityChoose',
         component: resolve => require(['./hotelBaseDate/hotelBaseDetail/detailFacilityChoose.vue'], resolve)
        },{
         name: 'roomList',
         path: '/base/hotelBaseDate/roomList',
         component: resolve => require(['./hotelBaseDate/roomList/roomList.vue'], resolve)
        },{
         name: 'pictureSet',
         path: '/base/hotelBaseDate/pictureSet',
         component: resolve => require(['./hotelBaseDate/roomList/pictureSet.vue'], resolve)
        },{
         name: 'roomDetail',
         path: '/base/hotelBaseDate/roomDetail',
         component: resolve => require(['./hotelBaseDate/roomList/roomDetail/roomDetail.vue'], resolve)
        },{
         name: 'roomFacilitySet',
         path: '/base/hotelBaseDate/roomFacilitySet',
         component: resolve => require(['./hotelBaseDate/roomList/roomDetail/roomFacilitySet.vue'], resolve)
        },{
         name: 'hotelPicture',
         path: '/base/hotelPicture/hotelPicture',
         component: resolve => require(['./hotelBaseDate/hotelPicture/hotelPicture.vue'], resolve)
        },{
         name: 'hotelPictureappearance',
         path: '/base/hotelPicture/appearance',
         component: resolve => require(['./hotelBaseDate/hotelPicture/appearance.vue'], resolve)
        },{
         name: 'hotelPicturemeetingRoom',
         path: '/base/hotelPicture/meetingRoom',
         component: resolve => require(['./hotelBaseDate/hotelPicture/meetingRoom.vue'], resolve)
        },{
         name: 'hotelPicturerelaxation',
         path: '/base/hotelPicture/relaxation',
         component: resolve => require(['./hotelBaseDate/hotelPicture/relaxation.vue'], resolve)
        },{
         name: 'hotelPicturerestaurant',
         path: '/base/hotelPicture/restaurant',
         component: resolve => require(['./hotelBaseDate/hotelPicture/restaurant.vue'], resolve)
        },{
         name: 'hotelPicturelobby',
         path: '/base/hotelPicture/lobby',
         component: resolve => require(['./hotelBaseDate/hotelPicture/lobby.vue'], resolve)
        },{
         name: 'hotelPictureguestRoom',
         path: '/base/hotelPicture/guestRoom',
         component: resolve => require(['./hotelBaseDate/hotelPicture/guestRoom.vue'], resolve)
        },{
         name: 'hotelPicturepublicArea',
         path: '/base/hotelPicture/publicArea',
         component: resolve => require(['./hotelBaseDate/hotelPicture/publicArea.vue'], resolve)
        },{
         name: 'hotelPicturerestaurant',
         path: '/base/hotelPicture/nearby',
         component: resolve => require(['./hotelBaseDate/hotelPicture/nearby.vue'], resolve)
        },{
         name: 'hotelPictureother',
         path: '/base/hotelPicture/other',
         component: resolve => require(['./hotelBaseDate/hotelPicture/other.vue'], resolve)
        },{
            name: 'brandList',
            path: '/base/hotelBaseDate/basicConfigurat/brandList',
            component: resolve => require(['./hotelBaseDate/basicConfigurat/brandList.vue'], resolve)
        },{//变更时限
            path: '/base/backtorule/changetimelist',
            name: 'changetimelist',
            component: resolve => require(['./backtorule/changetimelist.vue'], resolve)
        },{//变更时限
            path: '/base/backtorule/changetimeupdate',
            name: 'changetimeupdate',
            component: resolve => require(['./backtorule/changetimeupdate.vue'], resolve)
        },{//退改规则
            path: '/base/backtorule/RulesList',
            name: 'RulesList',
            component: resolve => require(['./backtorule/RulesList.vue'], resolve)
        },{//退改规则
            path: '/base/backtorule/RulesUpdate',
            name: 'RulesUpdate',
            component: resolve => require(['./backtorule/RulesUpdate.vue'], resolve)
        },{//舱位规则
            path: '/base/backtorule/ClassRulesList',
            name: 'ClassRulesList',
            component: resolve => require(['./backtorule/ClassRulesList.vue'], resolve)
        },{//舱位规则
            path: '/base/backtorule/ClassRulesUpdate',
            name: 'ClassRulesUpdate',
            component: resolve => require(['./backtorule/ClassRulesUpdate.vue'], resolve)
        }
    ]
}]



// WEBPACK FOOTER //
// ./src/views/base/router.js